import {AppShell, Avatar, Box, Button, Flex, Image, NavLink, rem} from '@mantine/core';
import React, {ReactNode} from 'react';
import {IconHome, IconMap, IconUserCircle} from "@tabler/icons-react";

interface LayoutProps {
    children: ReactNode;
    isAuthenticated: string;
    csrfToken: string;
    logoutUrl: string;
    userFirstname: string;
    userLastname: string;
    mainContainerColor?: string;
    asideComponent?: ReactNode;
    asideOpened?: boolean;
    staticBaseUrl: string;
}

const data = [
  { icon: IconHome, label: 'Home', href: '/report'},
  { icon: IconUserCircle, label: 'People List', href: '/matching/older_person' },
  { icon: IconMap, label: 'Map View', href: '/heatmap' },
];

const NavigationLayout: React.FC<LayoutProps> = ({
                                                     children,
                                                     isAuthenticated,
                                                     logoutUrl,
                                                     csrfToken,
                                                     mainContainerColor,
                                                     userFirstname,
                                                     userLastname,
                                                     asideComponent,
                                                     asideOpened,
                                                     staticBaseUrl
                                                 }) => {
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';

      const navItems = data.map((item, index) => {
            const isActive = currentPath === item.href || currentPath.startsWith(item.href + '/');

            return (
                <NavLink
                    href={item.href}
                    key={item.label}
                    active={isActive}
                    label={asideOpened ? '' : item.label}
                    leftSection={<item.icon size={asideOpened ? 22 : 16} stroke={2} color={'#6F767E'}/>}
                    autoContrast={true}
                    styles={{root: { fontSize: rem(15), lineHeight: rem(24), fontWeight: 600, color: '#6F767E', borderRadius: rem(12) }}}
                    variant="filled"
                    color="#EFEFEF"
              />
            )
          }
      );

    return (
        <AppShell
            layout="alt"
            header={{height: 96}}
            navbar={{
                width: asideOpened ? 96 : 300,
                breakpoint: 0
            }}
            aside={asideComponent && asideOpened ? { breakpoint: 0, width: 375 } : undefined}
        >
            <AppShell.Header withBorder={false} bg={"#FCFCFC"} >
                <Flex direction="row" justify="space-between" align="center" h={'100%'}>
                    <Box></Box>
                    {isAuthenticated === 'True' && (
                        <Flex p={rem(24)} gap={rem(18)} direction={'row'} align="center">
                            <Avatar color={'gray'} name={`${userFirstname} ${userLastname}`} radius="xl" />

                            <Button
                                component="a"
                                href="/password_change/"
                                variant="subtle"
                                color="#6F767E"
                            >
                                Change Password
                            </Button>

                            <form action={logoutUrl} method='POST'>
                                <input type="hidden" name="csrfmiddlewaretoken"
                                       value={csrfToken}/>
                                <Button variant="subtle" color={"#6F767E"} type="submit">Log out</Button>
                            </form>
                        </Flex>
                    )}
                </Flex>
            </AppShell.Header>

            <AppShell.Navbar p={rem(24)} bg={"#FCFCFC"}>
                <Button variant={'transparent'} w={48} mb={rem(48)} p={0} component={'a'} href={'/'}>
                    <Image src={`${staticBaseUrl}alone/images/logo.svg`} alt="Alone Logo"/>
                </Button>


                <Flex direction={'column'} gap={rem(8)}>
                    {navItems}
                </Flex>
            </AppShell.Navbar>

            <AppShell.Main bg={mainContainerColor}>{children}</AppShell.Main>

            {asideComponent && asideOpened && (
              <AppShell.Aside bg="#F4F4F4">
                {asideComponent}
              </AppShell.Aside>
            )}
        </AppShell>
    );
};

export default NavigationLayout;